var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M41.993 9.717v20.96h-5.287V15.661L9.744 41.5 6 37.912l26.962-25.838H17.293V7h24.7c.01 0 .007.958.003 1.761l-.002.603a2.4 2.4 0 0 1 0 .353",
    clipRule: "evenodd"
  })));
};
export default SvgExternal;